import el from "@cypherpotato/el";
import { MutedText } from "../components/text";

export async function runOperation(operationText, callback) {
    const waitingDialog = el("dialog.wait-dialog",
        el(".loader"),
        operationText && el("span", operationText)
    );

    window.currentWaitDialog = waitingDialog;

    try {
        document.body.classList.add("operation-running");
        document.body.appendChild(waitingDialog);
        waitingDialog.show();

        setTimeout(() => {
            waitingDialog.classList.add("visible");
        }, 150);

        return await callback();
    } finally {
        document.body.classList.remove("operation-running");
        waitingDialog.classList.remove("visible");
        setTimeout(() => {
            waitingDialog.remove();
            window.currentWaitDialog = null;
        }, 150);
    }
}

export function updateOperationText(text, altText) {
    if (window.currentWaitDialog) {
        const span = window.currentWaitDialog.querySelector("span");
        if (span) {
            if (altText) {
                span.textContent = '';
                span.appendChild(el.fragment(text, " ", MutedText(altText)));
            } else {
                span.textContent = text;
            }
        }
    }
}